export default __webpack_public_path__ + "static/media/ShopLight.8ae68be0.svg";